module.exports = __webpack_public_path__ + "static/media/9_pol_0_86.94.6f68a614.png";